const host = process.env.REACT_APP_URL


export const KTPOCR = `${host}api/v1/claim/extract-attribute-data/`
export const ImageQualityCheck = `${host}api/v1/claim/check-image-quality/`